import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/admin/admin-dashboard.css';

const AdminLayout = () => {
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const userString = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    
    if (!userString || !token) {
      navigate('/login');
      return; 
    }

    try {
      const user = JSON.parse(userString);

      if (user.rol !== 'admin') {
        alert('No tienes permisos para acceder a esta área.');
        localStorage.removeItem('user'); 
        localStorage.removeItem('token'); 
        navigate('/login');
      } else {
        setIsVerified(true);
      }
    } catch (error) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      navigate('/login');
    }

  }, [navigate]);

  if (!isVerified) {
    return null; 
  }

  return (
    <div className="admin-layout">
      <SideBar />
      <main className="admin-content">
        <Outlet /> 
      </main>
    </div>
  );
};

export default AdminLayout;